import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HttpModule } from '@angular/http';
import { NgSwitch } from '@angular/common'
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { LandingModule } from './landing/landing.module';
import { AppRoutingModule } from './app-routing.module';
import { FTRootComponent } from './app.component';
import { HomeComponent } from './landing/home/home.component';
import { LoginComponent } from './authentication/login/login.component';
import { RegisterComponent } from './authentication/register/register.component';
import { PrivacypolicyService } from './authentication/services/privacypolicy.service';
import {CannotregisterComponent } from './authentication/cannotregister/cannotregister.component';
// import { PrivacyPolicyComponent } from './authentication/privacy-policy/privacy-policy.component';
import { LoginstatusComponent } from './authentication/loginstatus/loginstatus.component';
import { AuthenticationService } from './authentication/services/authentication.service';
import { TemplateService } from './landing/services/template.service';
import { ProductService } from './shopping-cart/services/product.service';
import { UserService } from './authentication/services/user.service';
import { AccountService } from './authentication/services/account.service';
import { OrderConfirmationComponent } from './shopping-cart/order-confirmation/order-confirmation.component';
import { ThankYouComponent } from './shopping-cart/thank-you/thank-you.component';
import { EmailService } from './common/services/email.service';
import { PaymentConfirmationComponent } from './payment-gateway/payment-confirmation/payment-confirmation.component';
import { PaymentService } from './payment-gateway/services/payment.service';
import { PaymentReceiptComponent } from './payment-gateway/payment-receipt/payment-receipt.component';
import { PaymentCompletedMessageComponent } from './payment-gateway/payment-completed-message/payment-completed-message.component';
import { SessionManager } from './common/helpers/session-manager';
import { PaymentErrorMessageComponent } from './payment-gateway/payment-error-message/payment-error-message.component';
import { LaddaModule } from 'angular2-ladda';
import { PaymentProcessingComponent } from './payment-gateway/payment-processing/payment-processing.component';
import { AlertScreenComponent } from './alert-screen/alert-screen.component';
import { AppLoggingService } from './common/services/AppLogging.service';
import { InvoiceService } from './payment-gateway/services/invoice.service';
import { Localization } from './common/helpers/localization';
import { AutoLoginComponent } from './auto-login/auto-login.component';
import { PathRecommendationComponent } from './path-recommendation/path-recommendation.component';
import { TRANSLATION_PROVIDERS, TranslatePipe, TranslateService } from './translate';
import { PaymentAutoRenewComponent } from './payment-gateway/payment-auto-renew/payment-auto-renew.component';
import { AutorenewConfirmationComponent } from './payment-gateway/autorenew-confirmation/autorenew-confirmation.component';
// import { CannotregisterComponent } from './authentication/cannotregister/cannotregister.component';


/* const appRoutes: Routes=[
  { path:'login',component:LoginComponent },
  { path:'home',component:HomeComponent},
  { path:'',redirectTo:'home',pathMatch:'full'}
]; */

@NgModule({
  declarations: [
    FTRootComponent,
    LoginComponent,
    RegisterComponent,
    // PrivacyPolicyComponent,
    CannotregisterComponent,
    LoginstatusComponent,
    OrderConfirmationComponent,
    ThankYouComponent,
    PaymentConfirmationComponent,
    PaymentReceiptComponent,
    PaymentCompletedMessageComponent,
    PaymentErrorMessageComponent,
    PaymentProcessingComponent,
    AlertScreenComponent,
    AutoLoginComponent,
    PathRecommendationComponent,
    TranslatePipe,
    PaymentAutoRenewComponent,
    AutorenewConfirmationComponent
    // CannotregisterComponent
  ],

  imports: [
    BrowserModule,
    AppRoutingModule,
    LandingModule,
    HttpModule,
    FormsModule,
    ReactiveFormsModule,
    LaddaModule.forRoot({
      style: 'contract',
      spinnerSize: 40,
      spinnerColor: 'white',
      spinnerLines: 12
    }),
    /* RouterModule.forRoot(
      appRoutes,
      { enableTracing:true }
    ), */
  ],
  providers: [{ provide: LOCALE_ID, useValue: 'nb-No' }, AuthenticationService, TemplateService, ProductService, PrivacypolicyService,
    AccountService, UserService, EmailService, PaymentService, SessionManager, AppLoggingService, InvoiceService, Localization, NgSwitch, TRANSLATION_PROVIDERS, TranslateService],
  bootstrap: [FTRootComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/app.module.ts